import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import { useForm } from "react-hook-form"; // Import useForm from react-hook-form

import Addunits from "../../core/modals/inventory/addunits";
import AddCategory from "../../core/modals/inventory/addcategory";
import AddBrand from "../../core/modals/addbrand";
import { GetRequest, PatchRequest } from "../../Api/ApiFunctions";
import { ApiUrl, ConfUrl } from "../../Api/EndPoints";

import {
  ConfImageUploadService,
  flattenObject,
  ImageDataModalRequired,
  transformObject,
} from "./constants";
import TextArea from "./Components/TextArea";
import MultipleImage from "./Components/MultipleImage";
import MultiplePoints from "./Components/MultiplePoints";

const Home = () => {
  const route = all_routes;
  const [banner, setBanner] = useState([]);
  const [goingGreenImages, setgoingGreenImages] = useState([]);
  const [productRangeImages, setproductRangeImages] = useState([]);
  const [productPoints, setproductPoints] = useState([]);

  // const [Res, setRes] = useState("");
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { isSubmitting },
  } = useForm();

  const fetchData = async () => {
    const res = await GetRequest(`${ApiUrl.configuration}${ConfUrl.home}`);
    if (res) {
      setBanner(res?.value?.banner ?? []);
      setgoingGreenImages(res?.value?.goingGreenImages ?? []);
      setproductRangeImages(res?.value?.productRangeImages ?? []);
      setproductPoints(
        res?.value?.productRange?.points
          ? [res?.value?.productRange?.points]
          : []
      );
      const val = flattenObject(res?.value, "", ["banner"]);
      Object.keys(val).forEach((key) => {
        setValue(key, val[key]);
      });

      // setValue("confId", res.id);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSubmit = async (data) => {
    let Req = transformObject(data);

    Req.banner = await Promise.all(
      banner.map(async (it) => {
        let imgKey = null;
        if (it.image instanceof File) {
          imgKey = await ConfImageUploadService(it.image);
          console.log(it.image, "image");
        }
        return {
          key: it.key,
          image: imgKey ? imgKey : it.image,
          heading: it.heading,
          subHeading: it.subHeading,
          ctaBtn: it.ctaBtn,
          ctaLink: it.ctaLink,
        };
      })
    );
    Req.goingGreenImages = await Promise.all(
      goingGreenImages.map(async (it) => {
        let imgKey = null;
        if (it.image instanceof File) {
          imgKey = await ConfImageUploadService(it.image);
        }
        return {
          key: it.key,
          image: imgKey ? imgKey : it.image,
        };
      })
    );
    Req.productRangeImages = await Promise.all(
      productRangeImages.map(async (it) => {
        let imgKey = null;
        if (it.image instanceof File) {
          imgKey = await ConfImageUploadService(it.image);
        }
        return {
          key: it.key,
          image: imgKey ? imgKey : it.image,
        };
      })
    );
    if (productPoints?.length > 0) {
      Req.productRange.points = productPoints[0];
    }

    const resp = await PatchRequest(
      `${ApiUrl.configuration}${ConfUrl.home}`,
      Req
    );
    if (resp) {
      navigate(route.jobapplication);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Site Home</h4>
              {/* <h6>Create new Career</h6> */}
            </div>
          </div>
        </div>
        {/* /add */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body add-product pb-0">
              <div className="row">
                <h4>
                  <u>Banner</u>
                </h4>
                <div className="col-12">
                  <MultipleImage
                    id="banner"
                    dataSource={banner}
                    setDataSource={setBanner}
                    DataRequired={[
                      ImageDataModalRequired.image,
                      ImageDataModalRequired.heading,
                      ImageDataModalRequired.description,
                      ImageDataModalRequired.buttonText,
                      ImageDataModalRequired.buttonLink,
                    ]}
                  />
                </div>
                <h4>
                  <u>Section 1</u>
                </h4>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Year of Experience</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("section1_count", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("section1_heading", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-12">
                  <label className="form-label">Section content</label>
                  <TextArea
                    control={control}
                    id="section1_body"
                    placeholder="Section content"
                  />
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">CTA button</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("section1_ctaBtn", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">CTA Link</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("section1_ctaLink", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>

                <hr className="mt-2" />
                <h4>
                  <u>Section 2</u>
                </h4>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("section2_heading", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-12">
                  <label className="form-label">Section2 Content</label>
                  <TextArea
                    control={control}
                    id="section2_body"
                    placeholder="Section content"
                  />
                </div>
                <hr />
                <h4>
                  <u>Section 3</u>
                </h4>

                {/* //image */}
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("goingGreen_heading", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Sub Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("goingGreen_subheading", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-12">
                  <label className="form-label">Section3 Content</label>
                  <TextArea
                    control={control}
                    id="goingGreen_body"
                    placeholder="Section content"
                  />
                </div>
                <div className=" col-12">
                  <label className="form-label">Section3 Notes</label>
                  <TextArea
                    control={control}
                    id="goingGreen_notes"
                    placeholder="Section content"
                  />
                </div>
                <div className="col-12">
                  <MultipleImage
                    id="go_green"
                    dataSource={goingGreenImages}
                    setDataSource={setgoingGreenImages}
                    DataRequired={[ImageDataModalRequired.image]}
                  />
                </div>
                <hr />
                <h4>
                  <u>Counters</u>
                </h4>
                <div className="col-lg-4 col-sm-4 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Established</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("counts_established", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Locations</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("counts_locations", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Projects</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("counts_projects", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <hr />
                <h4>
                  <u>Section 4</u>
                </h4>
                <div className="col-lg-4 col-sm-4 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("productRange_heading", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">CTA Button</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("productRange_ctaBtn", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">CTA Link</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("productRange_ctaLink", {
                        required: "location is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-12">
                  <MultipleImage
                    id="product"
                    dataSource={productRangeImages}
                    setDataSource={setproductRangeImages}
                    DataRequired={[ImageDataModalRequired.image]}
                    DataLimit={4}
                  />
                </div>
                <MultiplePoints
                  Responsibilities={productPoints}
                  setResponsibilities={setproductPoints}
                  datalimit={1}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="btn-addproduct mb-4">
              <button type="button" className="btn btn-cancel me-2">
                Cancel
              </button>

              <button
                type="submit"
                className="btn btn-submit"
                // disabled={isSubmitting}
                // onClick={() => console.log("trapped")}
              >
                {isSubmitting ? (
                  <span className="spinner-border spinner-border-sm"></span>
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </form>
        {/* /add */}
      </div>
      <Addunits />
      <AddCategory />
      <AddBrand />
    </div>
  );
};

export default Home;
